module.exports = __webpack_public_path__ + "static/media/David Brady.bf0e0366.jpg";